// GENERATED by scripts/generate-country-dial-codes.mjs from libphonenumber-js 1.13.13
// (metadata v4), do not edit by hand; re-run the script instead.
//
// Tuple: [iso, name, dial, leading?]. Rows are grouped by calling code with the
// code's main country first. `leading` is a regex (anchored by the consumer)
// that identifies the national numbers of a territory sharing that code.
export type CountryDialRow = readonly [iso: string, name: string, dial: string, leading?: string];

export const COUNTRY_DIAL_DATA: ReadonlyArray<CountryDialRow> = [
  ["US","United States","+1"],
  ["AG","Antigua and Barbuda","+1","(?:268)\\d*"],
  ["AI","Anguilla","+1","(?:264)\\d*"],
  ["AS","American Samoa","+1","(?:684)\\d*"],
  ["BB","Barbados","+1","(?:246)\\d*"],
  ["BM","Bermuda","+1","(?:441)\\d*"],
  ["BS","Bahamas","+1","(?:242)\\d*"],
  ["CA","Canada","+1","(?:(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6})"],
  ["DM","Dominica","+1","(?:767)\\d*"],
  ["DO","Dominican Republic","+1","(?:8001|8[024]9)\\d*"],
  ["GD","Grenada","+1","(?:473)\\d*"],
  ["GU","Guam","+1","(?:671)\\d*"],
  ["JM","Jamaica","+1","(?:658|876)\\d*"],
  ["KN","Saint Kitts and Nevis","+1","(?:869)\\d*"],
  ["KY","Cayman Islands","+1","(?:345)\\d*"],
  ["LC","Saint Lucia","+1","(?:758)\\d*"],
  ["MP","Northern Mariana Islands","+1","(?:670)\\d*"],
  ["MS","Montserrat","+1","(?:664)\\d*"],
  ["PR","Puerto Rico","+1","(?:787|939)\\d*"],
  ["SX","Sint Maarten","+1","(?:721)\\d*"],
  ["TC","Turks and Caicos Islands","+1","(?:649)\\d*"],
  ["TT","Trinidad and Tobago","+1","(?:868)\\d*"],
  ["VC","Saint Vincent and Grenadines","+1","(?:784)\\d*"],
  ["VG","British Virgin Islands","+1","(?:284)\\d*"],
  ["VI","US Virgin Islands","+1","(?:340)\\d*"],
  ["RU","Russia","+7"],
  ["KZ","Kazakhstan","+7","(?:7)\\d*"],
  ["EG","Egypt","+20"],
  ["ZA","South Africa","+27"],
  ["GR","Greece","+30"],
  ["NL","Netherlands","+31"],
  ["BE","Belgium","+32"],
  ["FR","France","+33"],
  ["ES","Spain","+34"],
  ["HU","Hungary","+36"],
  ["IT","Italy","+39"],
  ["VA","Vatican City","+39","(?:06698)\\d*"],
  ["RO","Romania","+40"],
  ["CH","Switzerland","+41"],
  ["AT","Austria","+43"],
  ["GB","United Kingdom","+44"],
  ["GG","Guernsey","+44","(?:1481[25-9]\\d{5})|(?:7(?:(?:781|839)\\d|911[17])\\d{5})"],
  ["IM","Isle of Man","+44","(?:74576|(?:16|7[56])24)\\d*"],
  ["JE","Jersey","+44","(?:1534[0-24-8]\\d{5})|(?:7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5})"],
  ["DK","Denmark","+45"],
  ["SE","Sweden","+46"],
  ["NO","Norway","+47"],
  ["SJ","Svalbard and Jan Mayen","+47","(?:79)\\d*"],
  ["PL","Poland","+48"],
  ["DE","Germany","+49"],
  ["PE","Peru","+51"],
  ["MX","Mexico","+52"],
  ["CU","Cuba","+53"],
  ["AR","Argentina","+54"],
  ["BR","Brazil","+55"],
  ["CL","Chile","+56"],
  ["CO","Colombia","+57"],
  ["VE","Venezuela","+58"],
  ["MY","Malaysia","+60"],
  ["AU","Australia","+61"],
  ["CC","Cocos (Keeling) Islands","+61","(?:8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3})|(?:4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6})"],
  ["CX","Christmas Island","+61","(?:8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3})|(?:4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6})"],
  ["ID","Indonesia","+62"],
  ["PH","Philippines","+63"],
  ["NZ","New Zealand","+64"],
  ["SG","Singapore","+65"],
  ["TH","Thailand","+66"],
  ["JP","Japan","+81"],
  ["KR","South Korea","+82"],
  ["VN","Vietnam","+84"],
  ["CN","China","+86"],
  ["TR","Türkiye (Turkey)","+90"],
  ["IN","India","+91"],
  ["PK","Pakistan","+92"],
  ["AF","Afghanistan","+93"],
  ["LK","Sri Lanka","+94"],
  ["MM","Myanmar","+95"],
  ["IR","Iran","+98"],
  ["SS","South Sudan","+211"],
  ["MA","Morocco","+212"],
  ["EH","Western Sahara","+212","(?:528[89]\\d{5})|(?:(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|3[01]|5[0-5]))\\d{6})"],
  ["DZ","Algeria","+213"],
  ["TN","Tunisia","+216"],
  ["LY","Libya","+218"],
  ["GM","Gambia","+220"],
  ["SN","Senegal","+221"],
  ["MR","Mauritania","+222"],
  ["ML","Mali","+223"],
  ["GN","Guinea","+224"],
  ["CI","Côte d’Ivoire","+225"],
  ["BF","Burkina Faso","+226"],
  ["NE","Niger","+227"],
  ["TG","Togo","+228"],
  ["BJ","Benin","+229"],
  ["MU","Mauritius","+230"],
  ["LR","Liberia","+231"],
  ["SL","Sierra Leone","+232"],
  ["GH","Ghana","+233"],
  ["NG","Nigeria","+234"],
  ["TD","Chad","+235"],
  ["CF","Central African Republic","+236"],
  ["CM","Cameroon","+237"],
  ["CV","Cape Verde","+238"],
  ["ST","São Tomé and Príncipe","+239"],
  ["GQ","Equatorial Guinea","+240"],
  ["GA","Gabon","+241"],
  ["CG","Republic of the Congo","+242"],
  ["CD","DR Congo","+243"],
  ["AO","Angola","+244"],
  ["GW","Guinea-Bissau","+245"],
  ["IO","British Indian Ocean Territory","+246"],
  ["SC","Seychelles","+248"],
  ["SD","Sudan","+249"],
  ["RW","Rwanda","+250"],
  ["ET","Ethiopia","+251"],
  ["SO","Somalia","+252"],
  ["DJ","Djibouti","+253"],
  ["KE","Kenya","+254"],
  ["TZ","Tanzania","+255"],
  ["UG","Uganda","+256"],
  ["BI","Burundi","+257"],
  ["MZ","Mozambique","+258"],
  ["ZM","Zambia","+260"],
  ["MG","Madagascar","+261"],
  ["RE","Réunion","+262"],
  ["YT","Mayotte","+262","(?:26(?:89\\d|9(?:0[0-467]|15|5[0-4]|6\\d|[78]0))\\d{4})|(?:(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4})"],
  ["ZW","Zimbabwe","+263"],
  ["NA","Namibia","+264"],
  ["MW","Malawi","+265"],
  ["LS","Lesotho","+266"],
  ["BW","Botswana","+267"],
  ["SZ","Eswatini","+268"],
  ["KM","Comoros","+269"],
  ["SH","Saint Helena","+290"],
  ["ER","Eritrea","+291"],
  ["AW","Aruba","+297"],
  ["FO","Faroe Islands","+298"],
  ["GL","Greenland","+299"],
  ["GI","Gibraltar","+350"],
  ["PT","Portugal","+351"],
  ["LU","Luxembourg","+352"],
  ["IE","Ireland","+353"],
  ["IS","Iceland","+354"],
  ["AL","Albania","+355"],
  ["MT","Malta","+356"],
  ["CY","Cyprus","+357"],
  ["FI","Finland","+358"],
  ["AX","Åland Islands","+358","(?:18)\\d*"],
  ["BG","Bulgaria","+359"],
  ["LT","Lithuania","+370"],
  ["LV","Latvia","+371"],
  ["EE","Estonia","+372"],
  ["MD","Moldova","+373"],
  ["AM","Armenia","+374"],
  ["BY","Belarus","+375"],
  ["AD","Andorra","+376"],
  ["MC","Monaco","+377"],
  ["SM","San Marino","+378"],
  ["UA","Ukraine","+380"],
  ["RS","Serbia","+381"],
  ["ME","Montenegro","+382"],
  ["XK","Kosovo","+383"],
  ["HR","Croatia","+385"],
  ["SI","Slovenia","+386"],
  ["BA","Bosnia and Herzegovina","+387"],
  ["MK","North Macedonia","+389"],
  ["CZ","Czechia","+420"],
  ["SK","Slovakia","+421"],
  ["LI","Liechtenstein","+423"],
  ["FK","Falkland Islands","+500"],
  ["BZ","Belize","+501"],
  ["GT","Guatemala","+502"],
  ["SV","El Salvador","+503"],
  ["HN","Honduras","+504"],
  ["NI","Nicaragua","+505"],
  ["CR","Costa Rica","+506"],
  ["PA","Panama","+507"],
  ["PM","Saint Pierre and Miquelon","+508"],
  ["HT","Haiti","+509"],
  ["GP","Guadeloupe","+590"],
  ["BL","Saint Barthélemy","+590","(?:(?:59(?:0(?:2[7-9]|3[3-7]|5[12]|87)|87\\d)|80[6-9]\\d\\d)\\d{4})|(?:(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4})"],
  ["MF","Saint Martin","+590","(?:(?:59(?:0(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)|87\\d)|80[6-9]\\d\\d)\\d{4})|(?:(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\\d{4})"],
  ["BO","Bolivia","+591"],
  ["GY","Guyana","+592"],
  ["EC","Ecuador","+593"],
  ["GF","French Guiana","+594"],
  ["PY","Paraguay","+595"],
  ["MQ","Martinique","+596"],
  ["SR","Suriname","+597"],
  ["UY","Uruguay","+598"],
  ["CW","Curaçao","+599"],
  ["BQ","Caribbean Netherlands","+599","(?:[347])\\d*"],
  ["TL","Timor-Leste","+670"],
  ["NF","Norfolk Island","+672"],
  ["BN","Brunei","+673"],
  ["NR","Nauru","+674"],
  ["PG","Papua New Guinea","+675"],
  ["TO","Tonga","+676"],
  ["SB","Solomon Islands","+677"],
  ["VU","Vanuatu","+678"],
  ["FJ","Fiji","+679"],
  ["PW","Palau","+680"],
  ["WF","Wallis and Futuna","+681"],
  ["CK","Cook Islands","+682"],
  ["NU","Niue","+683"],
  ["WS","Samoa","+685"],
  ["KI","Kiribati","+686"],
  ["NC","New Caledonia","+687"],
  ["TV","Tuvalu","+688"],
  ["PF","French Polynesia","+689"],
  ["TK","Tokelau","+690"],
  ["FM","Micronesia","+691"],
  ["MH","Marshall Islands","+692"],
  ["KP","North Korea","+850"],
  ["HK","Hong Kong","+852"],
  ["MO","Macao","+853"],
  ["KH","Cambodia","+855"],
  ["LA","Laos","+856"],
  ["BD","Bangladesh","+880"],
  ["TW","Taiwan","+886"],
  ["MV","Maldives","+960"],
  ["LB","Lebanon","+961"],
  ["JO","Jordan","+962"],
  ["SY","Syria","+963"],
  ["IQ","Iraq","+964"],
  ["KW","Kuwait","+965"],
  ["SA","Saudi Arabia","+966"],
  ["YE","Yemen","+967"],
  ["OM","Oman","+968"],
  ["PS","Palestine","+970"],
  ["AE","United Arab Emirates","+971"],
  ["IL","Israel","+972"],
  ["BH","Bahrain","+973"],
  ["QA","Qatar","+974"],
  ["BT","Bhutan","+975"],
  ["MN","Mongolia","+976"],
  ["NP","Nepal","+977"],
  ["TJ","Tajikistan","+992"],
  ["TM","Turkmenistan","+993"],
  ["AZ","Azerbaijan","+994"],
  ["GE","Georgia","+995"],
  ["KG","Kyrgyzstan","+996"],
  ["UZ","Uzbekistan","+998"],
];
